import { ComponentType } from '@angular/cdk/portal';
import { TemplateRef } from '@angular/core';

import {
  CellActions,
  CellConfig,
  GridColumn,
  IIdentity,
  RowActions,
  Parameter,
} from '.';

export interface CellContext<T extends IIdentity> {
  column: GridColumn<T>;
  data: T;
  cell: {
    element: HTMLElement;
    actions: CellActions;
    allowEditing: boolean;
  };
  config?: CellConfig<T>;
  parameters?: Parameter;
  row?: {
    index?: number;
    actions?: RowActions;
    allowDeleting?: boolean;
  };
  type?: ComponentType<unknown> | TemplateRef<any>;
}
